export default __webpack_public_path__ + "static/media/dummy-profile-image.6a38ae8c.png";